import { createFileRoute } from '@tanstack/react-router';

import { SectionDetail } from '@/features/projects/SectionDetail';
import { ProjectModeProvider } from '@/features/projects/ProjectModeContext';

export const Route = createFileRoute('/_authenticated/fair-quote/$projectSlug/sections/$sectionSlug')({
  component: function Page() {
    const { projectSlug, sectionSlug } = Route.useParams();
    return (
      <ProjectModeProvider value='/fair-quote'>
        <SectionDetail projectSlug={projectSlug} sectionSlug={sectionSlug} />
      </ProjectModeProvider>
    );
  },
});
